query legalConsents($id: String!) {
  company(id: $id) {
    id
    legalConsents {
      identifier
      acceptedAt
    }
    state {
      stringValues
    }
  }
}
